<section class="container-fluid section-login" role="main" xmlns="http://www.w3.org/1999/html">
  <div class="col-12">
    <form [formGroup]="resetForm" (ngSubmit)="onClickSubmit()">
      <div class="contentBody">
        <h2>Password has expired on this user account. Please reset your password.</h2>
        <br /><br />
        @if (successMessage?.message?.length > 0) {
          <div class="padding-sides">
            <nfrp-alert alertId="login-success" type="success" [message]="successMessage" [page]="false"> </nfrp-alert>
          </div>
        }
        @if (errorMessage?.message?.length > 0) {
          <div class="padding-sides">
            <nfrp-alert alertId="login-error" [message]="errorMessage" type="error" [page]="false"> </nfrp-alert>
          </div>
        }
        <div id="userID" class="userDetails">
          <span class="detailTitle">New Password:</span>
          <input formControlName="newPassword" type="password" class="userDetailInput" [pattern]="passwordPattern" />
          <div class="inline-error">
            @if (((newPassword.touched && newPassword.invalid) || submitted) && newPassword.errors?.required) {
              <nfrp-inline-error
                errorId="password-required-error"
                [message]="'Password is required'"
                >
              </nfrp-inline-error>
            }
            @if (newPassword.touched && newPassword.errors?.pattern) {
              <nfrp-inline-error
                errorId="username-required-error"
                [message]="'Enter a valid password'"
                >
              </nfrp-inline-error>
            }
          </div>
        </div>
        <ul>
          <li>Password Must be at least 12 characters</li>
          <li>A mixture of both uppercase and lowercase letters</li>
          <li>A mixture of letters and numbers</li>
          <li>Inclusion of at least one special character, e.g., ! &#64; # ?</li>
        </ul>
        <div id="FirstName" class="userDetails">
          <span class="detailTitle">Confirm:</span>
          <input formControlName="confirmPassword" type="password" class="userDetailInput" />
        </div>
        <div class="inline-error">
          @if ((confirmPassword.touched || submitted) && confirmPassword.errors?.required) {
            <nfrp-inline-error
              errorId="confirm-pwd-required-error"
              [message]="'Confirm password is required'"
              >
            </nfrp-inline-error>
          }
          @if (confirmPassword.valid && resetForm.invalid && resetForm.errors.passwordsShouldMatch) {
            <nfrp-inline-error
              errorId="confirm-pwd-valid-error"
              [message]="'Passwords do not match.'"
              >
            </nfrp-inline-error>
          }
        </div>
        <div class="search-button" style="padding-left: 200px;">
          <input class="button-primary button" type="submit" value="Reset" />
        </div>
      </div>
    </form>
  </div>
</section>
